(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy-booking', {
            parent: 'entity',
            url: '/dinghy-booking?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyBooking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-booking/dinghy-bookings.html',
                    controller: 'DinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-booking-detail', {
            parent: 'dinghy-booking',
            url: '/dinghy-booking/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyBooking.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-detail.html',
                    controller: 'DinghyBookingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyBooking', function($stateParams, DinghyBooking) {
                    return DinghyBooking.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy-booking',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-booking-detail.edit', {
            parent: 'dinghy-booking-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-booking.new', {
            parent: 'dinghy-booking',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bookingDate: null,
                                price: null,
                                bookingStatus: null,
                                comment: null,
                                individualQuestionAnswer: null,
                                commentDinghy: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                validationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('dinghy-booking');
                });
            }]
        })
        .state('dinghy-booking.edit', {
            parent: 'dinghy-booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-booking.delete', {
            parent: 'dinghy-booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-delete-dialog.html',
                    controller: 'DinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
